import { saveAs } from 'file-saver';
import Api from './Api';
import Configuracao from '../util/Configuracao';

class AnexoApi extends Api {
  async download (id, filename) {
    try {
      const urlGuiaAnexo = `${Configuracao.getConfiguracao().urlGuiaAnexo}/${id}/${filename}`;
      const response = await this.fetch(urlGuiaAnexo, 'GET', null, null, 'blob');
      const { headers } = response;
      const blob = new Blob([response.data], { type: headers['content-type'] });
      saveAs(blob, headers['filename'] || filename);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async delete (id, filename) {
    try {
      const urlGuiaAnexo = `${Configuracao.getConfiguracao().urlGuiaAnexo}/${id}/${filename}`;
      const response = await this.fetch(urlGuiaAnexo, 'DELETE');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async upload (data) {
    try {
      const urlUploadAnexo = `${Configuracao.getConfiguracao().urlGuiaAnexo}/upload`;
      const response = await this.fetch(urlUploadAnexo, 'POST', data, { 'Content-Type': 'multipart/form-data' });
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default AnexoApi;
